import "../membershipLandingPage.scss";
import { useEffect, useState } from "react";
import Typography from "../../../../../../common/Typography";
import SubscribedMembListCard from "../SubscribedMembListCard";
import isEmpty from "../../../../../../../utils/constants/isEmpty";
import SingleMembershipLandingPage from "../SingleMembershipLandingPage";

const SubscribedMemberships = ({
  customerId,
  subscribedMemberships,
  showLoyaltyAndMembTabs,
}) => {
  const [currMemb, setCurrMemb] = useState({});
  const [isMultiMembrshpPage, setMultiMembrshpPage] = useState(true);

  useEffect(() => {
    if (isEmpty(currMemb)) {
      setMultiMembrshpPage(true);
      showLoyaltyAndMembTabs(true);
    } else {
      setMultiMembrshpPage(false);
      showLoyaltyAndMembTabs(false);
    }
  }, [currMemb]);

  return (
    <div className="membership-landing-page">
      {isMultiMembrshpPage ? (
        <div className="multiple-memberships-page">
          <Typography
            weight="medium"
            size="display-xxxl"
            customClass="membership-list-page-title"
          >
            Membership
          </Typography>
          <Typography
            weight="semibold"
            size="heading-md"
            customClass="membership-list-page-subtitle"
          >
            Subscribed
          </Typography>
          {subscribedMemberships?.map((memb) => (
            <SubscribedMembListCard
              memb={memb}
              setCurrMemb={setCurrMemb}
              key={memb?.membership_id}
            />
          ))}
        </div>
      ) : (
        <SingleMembershipLandingPage
          isShortlink={true}
          isShowBackBtn={true}
          setCurrMemb={setCurrMemb}
          setMultiMembrshpPage={setMultiMembrshpPage}
          currMemb={{ ...currMemb, customer_id: customerId }}
        />
      )}
    </div>
  );
};
export default SubscribedMemberships;
